const POLITE_ID = 'app-live-polite';
const ASSERTIVE_ID = 'app-live-assertive';

function createRegion(id: string, live: 'polite' | 'assertive'): HTMLDivElement {
    const region = document.createElement('div');
    region.id = id;
    region.className = 'sr-only';
    region.setAttribute('aria-live', live);
    region.setAttribute('aria-atomic', 'true');
    document.body.appendChild(region);
    return region;
}

export function LiveAnnouncer() {
    return (
        <>
            <div id={POLITE_ID} className="sr-only" aria-live="polite" aria-atomic="true" />
            <div id={ASSERTIVE_ID} className="sr-only" aria-live="assertive" aria-atomic="true" />
        </>
    );
}

export function announce(message: string, options?: { assertive?: boolean }) {
    const assertive = options?.assertive ?? false;
    const id = assertive ? ASSERTIVE_ID : POLITE_ID;
    const live = assertive ? 'assertive' : 'polite';
    const region = document.getElementById(id) ?? createRegion(id, live);

    region.textContent = '';
    window.setTimeout(() => {
        region.textContent = message;
    }, 100);
}
